module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gznpC"))).then(() => parcelRequire('fThBo'));